import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await fetch(`${BACKEND}/api/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ path: location.pathname, referrer: document.referrer }),
        });
      } catch {}
    };
    track();
  }, [location.pathname]);

  return null;
};

export default PageTracker;
